import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgUtil } from './ag-util';

export interface IIconCellRendererParams extends ICellRendererParams {
  /** Icon type, e.g. 'heroicons_outline:trash' */
  icon: string | ((params: IIconCellRendererParams) => string);
  /** Tooltip text on the icon */
  getToolTip: (params: ICellRendererParams) => string;
  /** Function that determines whether to display the icon */
  isVisible: (params: ICellRendererParams) => boolean;
  /** Function that determins if the icon is a button. Defaults to true. */
  isButton: (params: ICellRendererParams) => boolean;
  /** Function that determines whether the button is disabled */
  isDisabled: (params: ICellRendererParams) => boolean;
  /** Function called when the icon is clicked */
  onClick: (params: ICellRendererParams, event: PointerEvent) => void;
  /** Function that determines the color of the icon */
  color: (params: ICellRendererParams) => string;
  /** Function that determines the CSS class of the icon */
  class: (params: ICellRendererParams) => string;
}

@Component({
  selector: 'delete-icon-cell',
  template: ` <ng-container *ngIf="isVisible()">
    <button
      [class]="class()"
      *ngIf="isButton()"
      mat-icon-button
      (click)="onClick($event)"
      [disabled]="isDisabled()"
      [matTooltip]="getToolTip()"
      [color]="color()">
      <mat-icon [svgIcon]="params.icon"></mat-icon>
    </button>
    <mat-icon
      class="m-2 {{ class() }}"
      *ngIf="!isButton()"
      [matTooltip]="getToolTip()"
      [color]="color()"
      [svgIcon]="icon()"></mat-icon>
  </ng-container>`,
})
export class IconCellRendererComponent implements ICellRendererAngularComp {
  params: IIconCellRendererParams;

  isVisible(): boolean {
    const params = this.params;
    return params.isVisible ? params.isVisible(params) : true;
  }

  isButton(): boolean {
    const params = this.params;
    return params.isButton ? params.isButton(params) : true;
  }

  isDisabled(): boolean {
    const params = this.params;
    return params.isDisabled ? params.isDisabled(params) : false;
  }

  onClick(event: any): void {
    if (this.params.onClick instanceof Function) {
      this.params.onClick(this.params, event);
    }
  }

  color(): string {
    const params = this.params;
    return params.color ? params.color(params) : '';
  }

  class(): string {
    const params = this.params;
    return params.class ? params.class(params) : '';
  }

  icon(): string {
    const params = this.params;
    return params.icon ? (params.icon instanceof Function ? params.icon(params) : params.icon) : null;
  }

  getToolTip(): string {
    const params = this.params;
    return params.getToolTip ? params.getToolTip(params) : null;
  }

  agInit(params: IIconCellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}
